import { useTranslations } from '@vocab/react';
import { IconSearch, Text, Box, Inline } from 'braid-design-system';
import { observer } from 'mobx-react';
import { type FC, useEffect, useState } from 'react';

import translations from './.vocab';
import SearchBar from './SearchBar';

import * as styles from './FilterSearchBar.css';

interface Props {
  lastResultSearchText: string;
  value: string;
  onChange: (text: string) => void;
  onSearch: () => void;
}

export const FilterSearchBar: FC<Props> = observer(
  ({ value, lastResultSearchText, onSearch, onChange }) => {
    const { t } = useTranslations(translations);
    const [isActive, setIsSearchDisplayed] = useState(false);
    useEffect(() => {
      setIsSearchDisplayed(lastResultSearchText !== '');
    }, [lastResultSearchText]);

    const placeholder = t('Search names');

    return (
      <Box width="full">
        {isActive ? (
          <SearchBar
            value={value}
            lastResultSearchText={lastResultSearchText}
            onChange={onChange}
            onSearch={onSearch}
            placeholder={placeholder}
            onDisableActive={() => {
              setIsSearchDisplayed(false);
            }}
          />
        ) : (
          <Box
            component="button"
            aria-labelledby="search-text"
            cursor="pointer"
            width="full"
            onClick={() => {
              setIsSearchDisplayed(true);
            }}
            role="search"
            height="touchable"
          >
            <Box
              background="body"
              padding="small"
              className={styles.filterSearchButton}
            >
              <Text id="search-text" tone="secondary" size="small">
                <Inline space="xsmall">
                  <IconSearch
                    title={t('inactive search icon')}
                    titleId="inactive-search-icon"
                  />
                  <span>{placeholder}</span>
                </Inline>
              </Text>
            </Box>
          </Box>
        )}
      </Box>
    );
  },
);
